import { render, staticRenderFns } from "./SectionItemColumn.vue?vue&type=template&id=4e0e4a74&lang=pug&"
import script from "./SectionItemColumn.vue?vue&type=script&lang=js&"
export * from "./SectionItemColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports